<div class="container">
    <h2>Select a Tag</h2>
    <tools-table ApiPath="/teltonika/tags/" [Headers]="headers" #table [Search]="true" [HTTPPost]="false" [Slim]="true"
        [DisplayCount]="10" [ButtonRows]="true" (Selected)="selected($event)"></tools-table>
    <div class="buttons">
        <button mat-raised-button (click)="closeDialog(false)">Cancel</button>
    </div>
</div>